export interface WhatsAppContact {
  number: string;
  label: string;
  description: string;
  message: string;
}

export const WHATSAPP_CONTACTS: WhatsAppContact[] = [
  {
    number: '16043742074',
    label: 'General Enquiries',
    description: 'General inquiries & quotes',
    message: 'Hello, I have a general enquiry.'
  },
  {
    number: '16043742074',
    label: 'Operations Team',
    description: 'Service scheduling & updates',
    message: 'Hello, I need to contact operations.'
  }
];

export const openWhatsAppChat = (number: string, message: string): void => {
  const encodedMessage = encodeURIComponent(message);
  window.open(`https://wa.me/${number}?text=${encodedMessage}`, '_blank', 'noopener,noreferrer');
};

export const createServiceWhatsAppMessage = (serviceName: string): string => {
  return `Service Request: ${serviceName} — Hi, I'd like a quote/service for ${serviceName} in Metro Vancouver. Building type: ___. Address/City: ___. Timeline: ___. Details: ___.`;
};
